import { ButtonBase, Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	onClick: () => void;
	disabled?: boolean;
	backgroundColor: string;
	boxShadow?: string;
	children: ReactNode;
};

export const ChatAttachmentFileButton: FC<Props> = ({
	onClick,
	disabled,
	backgroundColor,
	boxShadow,
	children,
}) => {
	const theme = useTheme();
	const { message } = theme.chat;

	return (
		<Stack
			component={ButtonBase}
			direction="row"
			justifyContent="flex-start"
			textAlign="left"
			gap={theme.spacingTokens.sm}
			px={message.paddingX}
			py={message.paddingY}
			maxWidth="100%"
			borderRadius={theme.radii.xl}
			bgcolor={backgroundColor}
			boxShadow={boxShadow}
			disabled={disabled}
			onClick={onClick}
		>
			{children}
		</Stack>
	);
};
